export default __webpack_public_path__ + "static/media/09-ghidoni.89d7bc7f.mp4";